import { Component, ReactNode } from 'react';
import { AlertTriangle, RotateCcw } from 'lucide-react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('[ErrorBoundary]', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;
      return (
        <div className="flex flex-col items-center justify-center py-16 text-center">
          <div className="h-16 w-16 rounded-full bg-danger/10 flex items-center justify-center mb-4">
            <AlertTriangle size={32} className="text-danger" />
          </div>
          <h2 className="text-lg font-semibold mb-2">Coś poszło nie tak</h2>
          <p className="text-sm text-slate-500 max-w-md mb-4">
            {this.state.error?.message || 'Wystąpił nieoczekiwany błąd. Spróbuj odświeżyć stronę.'}
          </p>
          <button
            onClick={() => {
              this.setState({ hasError: false, error: null });
              window.location.reload();
            }}
            className="btn-primary flex items-center gap-2"
          >
            <RotateCcw size={16} />
            Odśwież
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
